require('./depositsProductBanners.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');
const PureRenderMixin = require('react-addons-pure-render-mixin');
//@components
const InterestsExample = require('components/interestsExample/interestsExample');
import { OfferExamples } from 'components/offersExample/offersExample';
const ProductBanner = require('components/commons/productBanner/productBanner');
const DEPOSITS_PRODUCT_BANNERS = require ('constants/productBanners/depositsProductBanners');
const RiskProduct = require('components/riskProduct/riskProduct');
const { OKMessage } = require('commonsComponents/OKMessage');
// @constants
const { DEPOSIT_CONTRACT_BUTTON } = require('constants/tagging');
//@core
const { FormattedText }= require('core/i18n').i18n;
class DepositsProductBanners extends React.Component {
    constructor(props) {
        super(props);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    filteredProducBanners () {
        const { immFlagBasedFeatures } = this.props;
        return (
            DEPOSITS_PRODUCT_BANNERS
            .filter( banner => immFlagBasedFeatures.get(banner.featureFlag))
        )
    }

    buildProductBanners() {
        const {  originCountry } = this.props;
        return (
            this.filteredProducBanners()
            .map( banner => {
                const { type, informativeText, title, id, sidebarImgAlt, sidebarImgUrl, sidebarImgUrlByCountry, advantages, subtitle, link } = banner;
                const children = type === 'deposits-informative' ? (
                    <OKMessage type="informative">
                        <FormattedText value={informativeText} />
                    </OKMessage>
                    ) 
                    : null;

                const sidebarImg = (sidebarImgUrlByCountry && sidebarImgUrlByCountry[originCountry.toLowerCase()]) || sidebarImgUrl;
                return (
                    <ProductBanner
                        key={id}
                        id={id}
                        title={title}
                        sidebarImgAlt={sidebarImgAlt}
                        sidebarImgUrl={sidebarImg}
                        subtitle={subtitle}
                        advantages={advantages}
                        link={link}
                        hasButton={type === 'deposits-informative' ? false : true}
                        customType={type ? type : null}
                        children={children}
                        processType={window.utag_last_name}
                        eventTag={DEPOSIT_CONTRACT_BUTTON}
                        linkText="productBanner-productBanner_depositsButton"
                    />
                )
            })
        )
    }

    render() {
        const { immFlagBasedFeatures, offersData, offerExamplesData, originCountry } = this.props;
        const hasRenewalOffers = offersData && Object.keys(offersData).length;
        const banners = this.buildProductBanners();
        return (
            this.filteredProducBanners().length > 0 ? (
                <section className="deposits-product-banners">
                    <header className="deposits-product-banners__header">
                        <FormattedText value="productBanner-meetDeposits" />
                    </header>
                    {
                        !hasRenewalOffers && (
                            <RiskProduct
                                immFlagBasedFeatures={immFlagBasedFeatures}
                                isAlertLiquidity={true}
                            />
                        )
                    }
                    {banners}
                    <div className="deposits-product-banners__examples">
                        <OfferExamples examples={offerExamplesData} originCountry={originCountry} />
                        <InterestsExample reducedTopSpacing={!!offerExamplesData.length} keyText={'productBanner-productBanner_depositsInterestsExample'} />
                    </div>
                </section>
            ) : (
                <section className="deposits-product-banners">
                    <div className="deposits-product-banners__examples">
                        <OfferExamples examples={offerExamplesData} originCountry={originCountry} />
                    </div>
                </section>
            )
        );
    }
}

DepositsProductBanners.propTypes = {
    immDeposits: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
};

module.exports = DepositsProductBanners;
